import i18n from '@/i18n';
const $t = (text) => {
  return i18n.global.t(text);
};

export const logCollection = [
  {
    id: 'productName',
    text: $t('searchLabel.productName'), // 모니터링 대상
    value: 'productName',
    width: 310,
    minWidth: 100,
    sortable: true,
    order: 1,
    isDefault: true,
    isVisible: true,
    isFixed: true,
    fixed: 'left'
  },
  {
    id: 'saType',
    text: $t('searchLabel.saType'), // 인스턴스 유형
    value: 'saType',
    width: 165,
    sortable: true,
    defaultValue: '',
    order: 2
  },
  {
    id: 'productIpAddress',
    text: $t('searchLabel.productIpAddress'), // IP 주소
    value: 'productIpAddress',
    width: 148,
    sortable: true,
    defaultValue: '-',
    isVisible: true
  },
  {
    id: 'dbVersion',
    text: $t('searchLabel.dbVersion'), // DB 버전
    value: 'dbVersion',
    width: 240,
    sortable: true,
    defaultValue: '-',
    order: 4444
  },
  {
    id: 'clusterName',
    text: $t('searchLabel.clusterName'), // 클러스터명, gpu 클러스터명
    value: 'clusterName',
    width: 150,
    sortable: true,
    defaultValue: '-'
  },
  {
    id: 'productState',
    text: $t('searchLabel.productState'), // 상품 상태
    value: 'productState',
    width: 160,
    sortable: true,
    isVisible: true,
    isFixed: true
  },
  {
    id: 'agentType',
    text: $t('searchLabel.agentType'), // 에이전트 유형
    value: 'agentTypeName',
    width: 140,
    bodyAlign: 'center',
    order: 30
  },
  {
    id: 'vmState',
    text: $t('searchLabel.vmState'), // vm 상태
    value: 'vmState',
    width: 120,
    sortable: true
  },
  {
    id: 'agentState',
    text: $t('searchLabel.agentState'), // 로그 에이전트 상태
    value: 'agentState',
    width: 290,
    order: 31
  },
  {
    id: 'logs',
    value: 'logs',
    width: 150,
    text: $t('searchLabel.logName'), // 활성화로그
    sortable: true
  },
  {
    id: 'metrics',
    value: 'metrics',
    text: $t('searchLabel.indi'), // 등록지표
    sortable: false,
    order: 32
  },
  {
    id: 'resourceName',
    text: $t('searchLabel.resourceName'), // 자원명
    value: 'resourceName',
    width: 250,
    sortable: true
  },
  {
    id: 'nodeType',
    text: $t('searchLabel.nodeType'), // 자원명
    value: 'nodeType',
    width: 250,
    sortable: true
  },
  {
    id: 'vpcName',
    text: $t('searchLabel.vpcName'), //'LB명',
    value: 'vpcName',
    width: 240,
    sortable: true,
    defaultValue: ''
  },
  {
    id: 'lbSize',
    text: $t('searchLabel.lbSize'), //'LB명',
    value: 'lbSize',
    width: 140,
    sortable: true,
    defaultValue: ''
  },
  {
    id: 'connectedVPC',
    text: $t('searchLabel.connectedVPC'), //'연결VPC',
    value: 'connectedVPC',
    width: 240,
    sortable: true,
    defaultValue: ''
  },
  {
    id: 'appVersion',
    text: $t('searchLabel.appVersion'),
    value: 'appVersion',
    width: 170,
    sortable: true,
    bodyAlign: 'center',
  }
];
